import { render } from "./VendorWriteCheck.vue?vue&type=template&id=6b037a1b"
import script from "./VendorWriteCheck.vue?vue&type=script&lang=js"
export * from "./VendorWriteCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__